
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.045 5.455a.729.729 0 00-.706.55l-1.68 6.722H9.09c.838 0 1.35.672 1.534 1.204a1.456 1.456 0 002.75 0c.184-.532.696-1.204 1.534-1.204h3.432l-1.68-6.722a.73.73 0 00-.706-.55h-7.91zm10.5 8.727H14.91l-.038.027a.485.485 0 00-.122.197 2.91 2.91 0 01-5.5 0 .484.484 0 00-.122-.197l-.04-.027H5.456v3.636c0 .402.325.727.727.727h11.636a.728.728 0 00.727-.727v-3.636zM5.928 5.652A2.182 2.182 0 018.045 4h7.91c1.001 0 1.874.681 2.117 1.652L20 13.365v4.453A2.182 2.182 0 0117.818 20H6.182A2.182 2.182 0 014 17.818v-4.453l1.928-7.713zm2.436 1.984c0-.401.325-.727.727-.727h5.818a.728.728 0 010 1.455H9.091a.728.728 0 01-.727-.728zm-.728 2.91c0-.402.326-.728.728-.728h7.272a.728.728 0 010 1.455H8.364a.728.728 0 01-.728-.727z"}})])
          )
        }
      }
    